import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { BookmarkTemplateService } from '../../services/bookmark-template.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { MatDialog } from '@angular/material';
import { BookmarksDialogComponent } from './bookmarks-dialog/bookmarks-dialog.component';
import { DocumentTemplateDialogComponent } from './document-template-dialog/document-template-dialog.component';
import { DocumentTemplate } from '../../models/document-template.model';

@Component({
  selector: 'bookmark-templates',
  template: require('./bookmark-templates.component.html'),
  styles: [require('./bookmark-templates.component.css')]
})
export class BookmarkTemplatesComponent implements OnInit {

    loadingIndicator: boolean = false;
    documentTemplates: DocumentTemplate[] = [];
    bookmarkGlobal = [];

    constructor(
        private bookmarkTemplateService: BookmarkTemplateService, public dialog: MatDialog
    ) { }

    ngOnInit() {
        this.getBookmarkGlobal();
        this.getDocumentTemplates();
    }

    getDocumentTemplates() {
        this.loadingIndicator = true;
        this.documentTemplates = [];
        this.bookmarkGlobal = [];
        this.bookmarkTemplateService.getBookmarkTemplates().subscribe(r => {
            this.documentTemplates = r.sort((a,b)=> a.otherIndex - b.ortherIndex);
            let temp = {
                name: 'Global Document Template',
                emailTemplatePath: null,
                documentBookmarksJson: null,
                documentTemplateBookmarks: this.bookmarkGlobal,
                documentTemplateId: null,
            } as DocumentTemplate;
            this.documentTemplates.unshift(temp)
            this.loadingIndicator = false;
        })
    }

    editBookmark(template) {
        let dialogRef = null;
        dialogRef = this.dialog.open(BookmarksDialogComponent, {
            panelClass: 'col-sm-10',
            height: '100%',
            data: template,
            disableClose: true
        })

        dialogRef.afterClosed().subscribe(r => {
            console.log('close')
            if (r) {
                this.getBookmarkGlobal();
                this.getDocumentTemplates();
            }
        } )
    }

    createTemplate() {
        let dialogRef = null;
        dialogRef = this.dialog.open(DocumentTemplateDialogComponent, {
            panelClass: 'col-sm-6',
        })
        dialogRef.afterClosed().subscribe(d => {
            if (d) {
                this.getBookmarkGlobal();
                this.getDocumentTemplates();
            }
        })
        
    }

    getBookmarkGlobal() {
        this.bookmarkTemplateService.getGlobalBookmarks().subscribe(r => {
            this.bookmarkGlobal = r;
        })
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/bookmark-templates/bookmark-templates.component.ts